<template>
  <div class="annotation-content">
    <div class="annotation-content__inner">
      <ul>
        <li>A-250819-10</li>
      </ul>
      <ul>
        <li>*1:株式会社ウェブクルーは火災保険の取扱代理店ではありませんので、火災保険の媒介・募集・販売行為は行いません。<br>ソニー損害保険株式会社、チューリッヒ保険株式会社は、株式会社Bang（以下、保険取扱代理店）と損害保険代理店委託契約を締結しており、当サイトにおいては保険取扱代理店が保険契約の媒介を行います。</li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.annotation-content {
  background: #F8F7F3;
  margin: 17.07% 0 0 0;
  padding: 6.4% 4.27% 12.8%;
  font-size: px(12);
  ul {
    text-indent: -1.3em;
    padding-left: 1.3em;
  }
  ul:first-of-type {
    margin: 0 0 3.2%;
  }
}
@include media(pc) {
  .annotation-content {
    margin: 80px 0 0 0;
    padding: 48px 0 64px;
    ul:first-of-type {
      margin: 0 0 12px;
    }
    &__inner {
      width: 960px;
      margin: 0 auto;
    }
  }
}
</style>